"use client";

import React, { useEffect, useRef, useState } from "react";
import AboutStylitCard from "@/src/components/StylistDescriptionCard/AboutStylistCard.js";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
// import Location1 from "@/assets/Company/AboutUs/Location1.jpg";
// import Location2 from "@/assets/Company/AboutUs/Location2.jpg";
// import Location3 from "@/assets/Company/AboutUs/Location3.jpg";
// import Location5 from "@/assets/Company/AboutUs/Location5.jpg";
// import Location6 from ;
// import Location7 from "@/assets/Company/AboutUs/Location7.jpg";
// import Slider2 from 
import ScrollCarousel from "scroll-carousel-react";
import { TeamDetails } from "@/src/fakeData/teamDetail.js";
import { Card, Container } from "@mui/material";
import { listCoupon } from "@/src/actions/couponActions.js";
import { useDispatch, useSelector } from "react-redux";
import SliderBannerShowData from "@/src/components/slider/sliderBanner.js";
import { listLocation } from "@/src/actions/locationActions.js";
import { listOurTeam } from "@/src/actions/ourTeamActions.js";
import LazyLoad from "react-lazyload";
import "./About.css";
import { seoData } from "@/src/fakeData/seoData.js";
import { Helmet } from "react-helmet";
import AboutCard from "./AboutCard.js";
// import AboutCard2 from "@/src/pages/AboutCard2.js";
import Slider from "@/src/components/slider/Slider.js";
import ChatPopup from "@/src/components/home/ChatPopup.js";
// import BlogHeader from "@";

const Spinner = () => (
  <div className="spinner">
    <style>{`
      .spinner {
        border: 4px solid rgba(0, 0, 0, 0.1);
        width: 36px;
        height: 36px;
        border-radius: 50%;
        border-left-color: #db2777;
        animation: spin 1s ease infinite;
      }
      @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
    `}</style>
  </div>
);

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export default function About() {
  const dispatch = useDispatch();
  const locationList = useSelector((state) => state.locationList);
  const ourTeamList = useSelector((state) => state.ourTeamList);
  const language = useSelector((state) => state.language.language);
  const location = locationList.location;
  const ourTeam = ourTeamList.ourTeam;

  const [isHover, setIsHover] = useState(false);
  const [duplicatedItems, setDuplicatedItems] = useState([]);
  const [showScrollButton, setShowScrollButton] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(listLocation());
    dispatch(listOurTeam());
  }, [dispatch]);

  useEffect(() => {
    if (ourTeam?.result) {
      setDuplicatedItems([...ourTeam.result, ...ourTeam.result]);
    }
  }, [ourTeam]);

  useEffect(() => {
    const handleScroll = () => setShowScrollButton(window.scrollY > 100);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const text = {
    title: language === "en" ? "Welcome to Door To Door Beauty" : "डोर टू डोर ब्यूटी में आपका स्वागत है",
    description1: language === "en"
    ? "Door To Door Beauty stands as a trusted leader in the realm of Door To Door Beauty services in India. Renowned as one of India's premier beauty service providers, Door To Door Beauty brings luxury beauty treatments to your doorstep. Operating in Noida, Greater Noida, Delhi, Gurgaon, Ghaziabad, and Bhopal, with plans for expansion across India, we deliver hands-on treatments performed by friendly, experienced, and caring beauty therapists in the comfort of your home. Doot To Door Beauty provides facials, makeup, waxing, manicure, pedicure, Brazilian bikini clean-up, hair care, body massage, polish, pre-bridal care, nail design, or mehndi design services right to your doorstep." 
    : "डोर टू डोर ब्यूटी भारत में घर-घर ब्यूटी सेवाओं के क्षेत्र में एक विश्वसनीय नेता के रूप में खड़ा है। भारत के प्रमुख ब्यूटी सेवा प्रदाताओं में से एक के रूप में प्रसिद्ध, डोर टू डोर ब्यूटी आपके दरवाजे पर शानदार ब्यूटी ट्रीटमेंट्स लाता है। नोएडा, ग्रेटर नोएडा, दिल्ली, गुरुग्राम, गाजियाबाद और भोपाल में संचालित, और पूरे भारत में विस्तार की योजना के साथ, हम आपके घर के आराम में मित्रवत, अनुभवी और देखभाल करने वाले ब्यूटी थेरेपिस्ट द्वारा किए गए बेहतरीन ट्रीटमेंट्स प्रदान करते हैं। डोर टू डोर ब्यूटी आपके घर पर फेशियल, मेकअप, वैक्सिंग, मैनीक्योर, पेडीक्योर, ब्राज़ीलियन बिकिनी क्लीन-अप, हेयर केयर, बॉडी मसाज, पॉलिश, प्री-ब्राइडल केयर, नेल डिज़ाइन, और मेहंदी डिज़ाइन सेवाएं प्रदान करता है।",

    description2: language === "en" 
    ? "Backed by a team of certified and skilled beauty professionals, Door To Door Beauty ensures your beauty needs are met with expertise and care. Our attentive staff ensures you feel confident entrusting us with your beauty requirements. Continuously updated on the latest techniques, our professional team is dedicated to addressing your concerns and providing solutions tailored to you. Committed to client satisfaction, we exclusively utilize the renowned Clarins product range in our face and body treatments."
    : "प्रमाणित और कुशल ब्यूटी पेशेवरों की एक टीम द्वारा समर्थित, डोर टू डोर ब्यूटी यह सुनिश्चित करता है कि आपकी ब्यूटी आवश्यकताओं को विशेषज्ञता और देखभाल के साथ पूरा किया जाए। हमारा ध्यानपूर्वक प्रशिक्षित स्टाफ आपको आश्वस्त करता है कि आप अपनी ब्यूटी जरूरतों को हमारे साथ सुरक्षित महसूस कर सकते हैं। नवीनतम तकनीकों के साथ निरंतर अपडेट रहने वाली हमारी पेशेवर टीम आपकी समस्याओं का समाधान करने और आपके लिए अनुकूल सेवाएं प्रदान करने के लिए समर्पित है। ग्राहक संतुष्टि के प्रति प्रतिबद्ध, हम अपने फेस और बॉडी ट्रीटमेंट्स में विशेष रूप से प्रतिष्ठित क्लैरिन्स प्रोडक्ट रेंज का उपयोग करते हैं।",
    ourTeamtitle: language === "en" ? "Our Team" : "हमारी टीम",
  };

  const { title, description, keywords, author } = seoData.about;
  const carouselStyle = {
    display: "flex",
    transition: "transform 0.3s ease-in-out",
    overflowX: "auto",
  };
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="author" content={author} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <link rel="canonical" href="https://www.doortodoorbeauty.com/about-us" />
      </Helmet>

      <div className="bg-gray-50">
        <ChatPopup />

        {/*<div
          className="flex justify-center py-10 lg:py-20 bg-indigo-100 w-full bg-cover bg-no-repeat bg-bottom"
          style={{ backgroundImage: `url('/assets/Blog/BlogHeader.jpg')` }}
        >
          <div className="flex mx-auto w-full max-w-screen-2xl px-3 sm:px-10">
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold font-serif text-center text-pink-600">
              About Us
            </h2>
          </div>
        </div>*/}

        <div className="flex justify-center py-10 lg:py-20 bg-indigo-100 w-full bg-cover bg-no-repeat bg-bottom" 
            style={{ backgroundImage: `url('/assets/Blog/BlogHeader.jpg')` }}>
            <div className="flex mx-auto w-full max-w-screen-2xl px-3 sm:px-10">
                <div className="w-full flex justify-center flex-col relative">
                    <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold font-serif text-center text-pink-600" style={{color: '#DB2777'}}>About Us</h1>
                </div>
            </div>
        </div>






        <div className="bg-white">
          {/* Description and slider */}
          <div className="max-w-screen-2xl mx-auto lg:py-20 py-10 px-4 sm:px-10">
            <div className="grid lg:grid-cols-2 gap-4 lg:gap-16">
              <div className="text-justify">
                <h2 className="text-6xl sm:text-6xl md:text-6xl lg:text-3xl mb-2 font-bold font-semibold">
                  {text.title}
                </h2>
                <p className="mt-3 text-base opacity-90 leading-7">{text.description1}</p>
                <br />
                <p className="text-base opacity-90 leading-7">{text.description2}</p>
              </div>
              <Box
                component="img"
                src="/assets/Company/TopSlider/Slider2.jpg"
                sx={{
                  border: "2px solid #DB2777",
                  borderRadius: "16px",
                  borderBottomRightRadius: "50px",
                  borderTopLeftRadius: "40px",
                  height: { xs: 510, sm: 510, md: 510, lg: 430 },
                  width: { xs: 700, sm: 700, md: 700, lg: 700 },
                  display: "flex",
                  justifyContent: { xs: "center", lg: "flex-start" },
                  alignItems: "center",
                  margin: "auto",
                }}
              />
            </div>

            {/* Location grid */}


            <div className="max-w-screen-xl mx-auto px-4 sm:px-10 py-10 lg:py-20">
  <div className="flex flex-wrap -mx-2">
    {location?.result?.map((item, index) => (
      <div key={index} className="w-full sm:w-1/2 lg:w-1/4 px-2 mb-6">
        <div className="border-2 border-[#DB2777] rounded-2xl overflow-hidden bg-white">
          <img
            loading="lazy"
            src={item.photo_url}
            alt={`${item.name} Image`}
            className="w-full rounded-t-2xl"
          />
          <div className="flex justify-center mt-[-10px]">
            <a
  className="px-6 py-2 text-center rounded-full no-underline hover:no-underline font-bold"
  style={{
    color: 'white',
    backgroundColor: '#DB2777',
    marginBottom: '10px',
  }}
>
              {language === 'en' ? item.name : item.name_hindi}
            </a>
          </div>
        </div>
      </div>
    ))}

    {/* Static Varanasi Card */}
    <div className="w-full sm:w-1/2 lg:w-1/4 px-2 mb-6">
      <div className="border-2 border-[#DB2777] rounded-2xl overflow-hidden bg-white">
        <img
          loading="lazy"
          src="/assets/Company/AboutUs/Location6.jpg"
          alt="Location Image"
          className="w-full rounded-t-2xl"
        />
        <div className="flex justify-center mt-[-10px]">
<a
  className="px-6 py-2 text-center rounded-full no-underline hover:no-underline font-bold"
  style={{
    color: 'white',
    backgroundColor: '#DB2777',
    marginBottom: '10px',
  }}
>
            {language === 'en'
              ? 'Varanasi (Coming Soon)'
              : 'वाराणसी (जल्द आ रहा है)'}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

          </div>

          {/* Our Team carousel */}
          <div className="bg-gray-50 lg:py-24 py-14 lg:mt-[-240px]">
            <div className="max-w-screen-2xl mx-auto px-3 sm:px-10">
              <h3 className="text-3xl sm:text-4xl lg:text-3xl mb-2 font-bold">
                {text.ourTeamtitle}
              </h3>
              <div
                className="carousel-container overflow-hidden py-13"
                style={{ padding: 20 }}
                onMouseEnter={() => setIsHover(true)}
                onMouseLeave={() => setIsHover(false)}
              >
                <div style={carouselStyle}>
                  {duplicatedItems.map((item, index) => (
                    <div key={`${item.id}-${index}`} className="carousel-item" style={{ margin: "10px", flexShrink: 0 }}>
                      <AboutCard item={item} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>




        <AboutStylitCard />

        {showScrollButton && (
          <button
            className="fixed bottom-[100px] right-8 bg-pink-600 hover:bg-emerald-600 text-white p-3 rounded-full shadow-lg"
            onClick={scrollToTop}
          >
            ⬆️
          </button>
        )}
      </div>
    </>
  );
}
